import {
  NotificationChannelValue,
  NotificationPreference,
  NotificationSettings,
} from '@property/shared';
import { useUpdateNotificationSettings } from '@/hooks/use-notification-settings';
import { WhatsAppNotificationCard } from './whatsapp-notification-card';
import { EmailNotificationCard } from './email-notification-card';

function isChannelEnabled(
  settings: NotificationSettings,
  channel: NotificationChannelValue,
  fallback: boolean,
): boolean {
  return settings.preferences.find((p) => p.channel === channel)?.enabled ?? fallback;
}

export function NotificationSettingsForm({ settings }: { settings: NotificationSettings }) {
  const updateSettings = useUpdateNotificationSettings();

  const setChannelEnabled = (channel: NotificationChannelValue, enabled: boolean) => {
    const current: NotificationPreference[] = [
      { channel: 'email', enabled: isChannelEnabled(settings, 'email', true) },
      { channel: 'whatsapp', enabled: isChannelEnabled(settings, 'whatsapp', false) },
    ];
    const preferences = current.map((p) => (p.channel === channel ? { ...p, enabled } : p));
    updateSettings.mutate({ preferences });
  };

  return (
    <div className="max-w-xl space-y-4">
      <WhatsAppNotificationCard
        settings={settings}
        enabled={isChannelEnabled(settings, 'whatsapp', false)}
        onToggle={(enabled) => setChannelEnabled('whatsapp', enabled)}
      />
      <EmailNotificationCard
        enabled={isChannelEnabled(settings, 'email', true)}
        onToggle={(enabled) => setChannelEnabled('email', enabled)}
      />
    </div>
  );
}
